export default __webpack_public_path__ + "static/runa_1_1_de-263c5dc2bf68ce4be63d587bd7f9b67b.png";